module.exports = __webpack_public_path__ + "static/media/office-a.c933c8e2.svg";